import { render, staticRenderFns } from "./all-width-layout.vue?vue&type=template&id=4479523d&scoped=true&"
import script from "./all-width-layout.vue?vue&type=script&lang=js&"
export * from "./all-width-layout.vue?vue&type=script&lang=js&"
import style0 from "./all-width-layout.vue?vue&type=style&index=0&id=4479523d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479523d",
  null
  
)

export default component.exports